import { Injectable, Injector } from "@angular/core";

import {
  Controller,
  HttpGet,
  resultOf,
  FromRoute,
  HttpPost,
  FromBody,
  Produce,
  SuccessTestCase,
  SuccessResult,
  HttpStatusResult,
  FailedTestCase,
  VerificationFailedResult,
  UnauthorizedResult,
  InvalidModelResult,
} from "@jct/core";
import { DonationFaildModel, DonationModel } from "./donation-types";

@Injectable({ providedIn: "root" })
@Controller("donation")
export class DonationService {
  constructor(protected injector: Injector) {}

  donation: DonationModel;
  donationDetailesComplete: boolean = false;
  successPaymentComplete:boolean=false;

  @HttpPost("sendEmailAboutFirstDetails")
  @Produce(HttpStatusResult)
  sendEmailAboutFirstDetails(@FromBody() model: DonationModel) {
    return resultOf();
  }

  @HttpPost("beginPayment")
  @Produce("string")
  beginPaymentProcessViaCGAsync(@FromBody() model: DonationModel) {
    return resultOf<string>();
  }

  @HttpPost("{transactionId}/success")
  @Produce(HttpStatusResult)
  endPaymentAsync(
    @FromRoute("transactionId") transactionId: string,
    @FromBody("token") token: string
  ) {
    return resultOf();
  }

  @HttpPost("{transactionId}/failed")
  @SuccessTestCase(SuccessResult)
  @FailedTestCase(VerificationFailedResult)
  @Produce(HttpStatusResult)
  receiveFailedPaymentAsync(@FromBody() model: DonationFaildModel) {
    return resultOf();
  }

  @HttpPost("{transactionId}/cancel")
  @SuccessTestCase(SuccessResult)
  @FailedTestCase(VerificationFailedResult)
  @Produce(HttpStatusResult)
  cancelPaymentAsync(@FromRoute("transactionId") transactionId: string) {
    return resultOf();
  }
}


